module.exports = __webpack_public_path__ + "static/media/Sekolah kambang.8df0eb2c.PNG";